import { FunctionComponent, useEffect, useState } from "react";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Form, Input, Spin } from "antd";
import { ROLE_UTILISATEUR } from "../../services/user";
import { AuthLayout } from "../../components/layout/AuthLayout";

type FieldType = {
    username: string;
    password: string;
};

export const SignIn: FunctionComponent = () => {

    const { login, authenticate, handleAuthorizationCode, username, roles } = useAuth();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [loginFailed, setLoginFailed] = useState(false);

    const getRedirectForRoles = (userRoles: string[]) => {
        if (userRoles.includes("ROLE_ADMIN") || userRoles.includes("ROLE_ENSEIGNANT") || userRoles.includes("ROLE_TRESORIER")) {
            return "/admin";
        }
        if (userRoles.includes(ROLE_UTILISATEUR)) {
            return "/mesInscriptions";
        }
        return "/";
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        const state = params.get("state");

        const init = async () => {
            if (code) {
                const result = await handleAuthorizationCode(code, state);
                if (result && result.from && result.from !== "/") {
                    navigate(result.from);
                } else {
                    navigate(getRedirectForRoles(result?.roles ?? []));
                }
            } else if (username) {
                navigate(getRedirectForRoles(roles));
            }
        };

        init();
    }, []);

    const onFinish = async (values: FieldType) => {
        setLoginFailed(false);
        setIsLoading(true);
        try {
            await authenticate(values.username, values.password);
            await login();
        } catch (error) {
            setLoginFailed(true);
            setIsLoading(false);
        }
    };

    return (
        <AuthLayout title="Connexion" subtitle="Accédez à votre espace">
            <Form<FieldType>
                name="login"
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
            >
                <Spin spinning={isLoading}>
                    {loginFailed && (
                        <Form.Item>
                            <Alert type="error" message="Identifiants incorrects" showIcon />
                        </Form.Item>
                    )}
                    <Form.Item<FieldType>
                        label="Nom d'utilisateur"
                        name="username"
                        rules={[{ required: true, message: "Veuillez saisir votre nom d'utilisateur" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="Mot de passe"
                        name="password"
                        rules={[{ required: true, message: "Veuillez saisir votre mot de passe" }]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Se connecter
                        </Button>
                    </Form.Item>
                    <div style={{ textAlign: "center" }}>
                        <Button type="link" onClick={() => navigate("/resetPassword")}>
                            Mot de passe oublié ?
                        </Button>
                    </div>
                </Spin>
            </Form>
        </AuthLayout>
    );

}
